/** Freude-Moment: Limette-/Violett-Konfetti (CSS-Animation, ≤ 1,5 s) und optional ein leiser Ton. Respektiert „Bewegung reduzieren“. */
import { useEffect, useMemo } from "react";

export function Konfetti({ aktiv, ton }: { aktiv: boolean; ton: boolean }) {
  const reduziert = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const teile = useMemo(() => Array.from({ length: 28 }, (_, i) => ({ i, x: Math.random() * 100, d: 0.6 + Math.random() * 0.9, r: Math.random() * 360, s: 6 + Math.random() * 8, v: i % 3 })), []);
  useEffect(() => {
    if (!aktiv || !ton) return;
    try {
      const ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
      const t = ctx.currentTime;
      for (const [f, start] of [[660, 0], [880, 0.09], [1320, 0.18]] as const) {
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "sine";
        o.frequency.value = f;
        g.gain.setValueAtTime(0.0001, t + start);
        g.gain.exponentialRampToValueAtTime(0.08, t + start + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + start + 0.25);
        o.connect(g).connect(ctx.destination);
        o.start(t + start);
        o.stop(t + start + 0.3);
      }
      setTimeout(() => void ctx.close(), 800);
    } catch {
      // kein Ton möglich
    }
  }, [aktiv, ton]);
  if (!aktiv || reduziert) return null;
  return (
    <div className="mp-konfetti" aria-hidden="true">
      {teile.map((t) => (
        <i key={t.i} className={`mp-konfetti__teil mp-konfetti__teil--${t.v}`} style={{ left: `${t.x}%`, animationDuration: `${t.d + 0.8}s`, animationDelay: `${(t.i % 7) * 0.05}s`, width: t.s, height: t.s * 0.6, transform: `rotate(${t.r}deg)` }} />
      ))}
    </div>
  );
}
